import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cylinder",
  "use": "icon-cylinder-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"https://www.w3.org/2000/svg\" xmlns:xlink=\"https://www.w3.org/1999/xlink\" id=\"icon-cylinder\">\n  <path d=\"M916.48 335.552C910.592 11.648 113.408 11.52 107.52 335.552v352c0 324.16 809.344 325.376 809.472 0zM264.448 213.44C572.736 35.008 1063.68 287.104 759.552 463.424 448.448 643.776-38.4 389.248 264.448 213.44z m588.288 474.432c0 105.344-165.44 182.464-340.736 183.744-175.296-1.28-340.672-78.4-340.736-183.744V473.6c158.208 150.72 521.536 152.384 681.472 0z\" p-id=\"7989\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/cylinder.svg
// module id = 4Tg7
// module chunks = 12